{
  "sectionHeader": "Statistiek van verlaten tijd",
  "sectionPara": "U kunt ook specifiek de drempel(s) voor verlaten duur aanpassen, die worden gebruikt door de zeven varianten van inkomende verlaten statistieken in de stijl van \"Verlaten < = Xs\".",
  "target1Label": "Doel 1:",
  "target1Placeholder": "60",
  "target2Label": "Doel 2:",
  "target2Placeholder": "90",
  "target3Label": "Doel 3:",
  "target3Placeholder": "120",
  "target4Label": "Doel 4:",
  "target4Placeholder": "150",
  "target5Label": "Doel 5:",
  "target5Placeholder": "180",
  "target6Label": "Doel 6:",
  "target6Placeholder": "300",
  "targetUnits": "s",
  "resetAnswerTargetsButtonLabel": "Verlaten intervallen resetten",
  "resetAnswerTargetsPrompt": "Weet u zeker dat u alle 6 instellingen voor de verlaten drempel voor inkomend verkeer wilt terugzetten naar hun standaardwaarden?",
  "resetAnswerTargetsConfirm": "Bevestigen",
  "resetAnswerTargetsCancel": "Annuleren",
  "NAME": "AbandonedTimeStatisticLanguage"
}